import header from './layout/header.js'
import body from './layout/body.js'
import modal from './layout/modal.js'

const scaffolding = function() {
    header.init()
    body.init()
    modal.init()
}

export default scaffolding